import type {
	BaseMetricDataWithStartAndStop,
	PerformanceEventConfig,
	ShareableGlobalConfig,
} from '../../types';

export const traceContext = (
	_config: PerformanceEventConfig,
	data: BaseMetricDataWithStartAndStop,
	_globalConfig: ShareableGlobalConfig,
): { tracingContext: { 'X-B3-TraceId': string; 'X-B3-SpanId': string } } | null => {
	if (!data.traceContext) {
		return null;
	}
	return {
		tracingContext: {
			'X-B3-TraceId': data.traceContext.traceId,
			'X-B3-SpanId': data.traceContext.spanId,
		},
	};
};
